import React, { useRef } from 'react';
import { motion } from 'framer-motion';

export type CheckBoxProps = {
  checked: boolean;
  className?: string;
  checkClassName?: string;
  label?: string;
  onChange?: (event?: any) => any;
  id?: string;
};

const Checkbox = ({
  checked,
  onChange,
  className,
  checkClassName,
  label = '',
  id,
}: CheckBoxProps) => {
  const checkboxEl = useRef();
  return (
    <label className="Checkbox">
      <svg viewBox="0 0 420 400" className={className}>
        <motion.path
          className={checkClassName}
          d="M 50 130 L 120 200 L 280 0"
          transform="translate(35 100)"
          stroke="currentColor"
          fill="transparent"
          strokeWidth="75"
          strokeLinecap="round"
          strokeLinejoin="round"
          initial={{
            pathLength: checked ? 1 : 0,
            opacity: checked ? 1 : 0,
          }}
          animate={{
            pathLength: checked ? 1 : 0,
            opacity: checked ? 1 : 0,
          }}
          exit={{
            pathLength: 0,
            opacity: 0,
          }}
          transition={{
            duration: 0.2,
          }}
        />
      </svg>
      <input
        id={id}
        ref={checkboxEl}
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />
      {label}
    </label>
  );
};

export default Checkbox;
